import { render, staticRenderFns } from "./PreOrderDetailSuperAdmin.vue?vue&type=template&id=cd1684ca&scoped=true"
import script from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
export * from "./PreOrderDetailSuperAdmin.vue?vue&type=script&lang=js"
import style0 from "./PreOrderDetailSuperAdmin.vue?vue&type=style&index=0&id=cd1684ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1684ca",
  null
  
)

export default component.exports